<template>
  <el-row>
    <el-row
      v-if="showCard('information')"
      :gutter="10"
    >
      <el-col :md="8">
        <Information :consignment="consignment" />
      </el-col>
      <el-col :md="5">
        <Sender :consignment="consignment" />
      </el-col>
      <el-col :md="5">
        <Receiver :consignment="consignment" />
      </el-col>
      <el-col :md="6">
        <Features :consignment="consignment" />
      </el-col>
    </el-row>
    <br>
    <el-row
      v-if="showCard('items')"
      :gutter="10"
    >
      <el-col :md="24">
        <el-card
          header="Items"
          shadow="never"
        >
          <div
            slot="header"
            class="clearfix"
          >
            <span>
              Items
            </span>
            <el-button-group style="float: right;">
              <el-button
                v-clipboard:copy="itemDetails"
                v-clipboard:success="() => $message.success('Items copied to clipboard')"
                style="padding: 3px 0"
                type="text"
              >
                Copy
              </el-button>
            </el-button-group>
          </div>
          <ItemTable :consignment="consignment" />
        </el-card>
      </el-col>
    </el-row>
    <br>
    <el-row
      v-if="showCard('tracking')"
      :gutter="10"
    >
      <el-col :md="24">
        <TrackingCard
          ref="trackingCard"
          :consignment="consignment"
        />
      </el-col>
    </el-row>
    <br>
    <el-row
      v-if="showCard('tracking errors')"
      :gutter="10"
    >
      <el-col :md="24">
        <TrackingErrors
          ref="trackingErrors"
          :errors="consignment.tracking_errors"
          :consignment="consignment"
        />
      </el-col>
    </el-row>
    <br>
    <el-row
      v-if="showCard('quoted pricing')"
      :gutter="10"
    >
      <el-col :md="24">
        <QuotedPricingTable :pricing="consignment.quoted_pricing" />
      </el-col>
    </el-row>
    <br>
    <el-row
      v-if="showCard('manifest pricing')"
      :gutter="10"
    >
      <el-col :md="24">
        <ManifestPricingTable :pricing="getPricingData()" />
      </el-col>
    </el-row>
    <br>
    <el-row
      v-if="showCard('pricing and margin')"
      :gutter="10"
    >
      <el-col :md="24">
        <PricingAndMargin
          ref="pricingAndMargin"
          :consignment="consignment"
        />
      </el-col>
    </el-row>
  </el-row>
</template>

<script>
import TrackingCard from '@/components/Application/Freight/Consignments/Tracking/Card'
import ItemTable from '@/components/Application/Freight/Consignments/Items/Table'
import TrackingErrors from '@/components/Application/Freight/Consignments/Tracking/Errors'
import Sender from '@/components/Application/Freight/Consignments/Peek/Sender'
import Receiver from '@/components/Application/Freight/Consignments/Peek/Receiver'
import Information from '@/components/Application/Freight/Consignments/Peek/Information'
import QuotedPricingTable from '@/components/Application/Freight/Consignments/QuotedPricingTable'
import ManifestPricingTable from '@/components/Application/Freight/Consignments/ManifestPricingTable'
import PricingAndMargin from '@/components/Application/Freight/Consignments/PricingAndMargin'
import Features from '@/components/Application/Freight/Consignments/Peek/Features'

export default {
  components: {
    TrackingCard,
    ItemTable,
    TrackingErrors,
    Sender,
    Receiver,
    Information,
    QuotedPricingTable,
    ManifestPricingTable,
    PricingAndMargin,
    Features
  },
  props: {
    consignment: {
      type: Object,
      required: true
    },
    showCards: {
      type: Array,
      required: false,
      default: () => undefined
    }
  },
  data () {
    return {
      latestEvent: Object(),
      isEditingReceiver: false,
      configuration: Object(),
      selectedViews: []
    }
  },
  computed: {
    senderDetails () {
      return 'Sender' + '\n' + this.consignment.con_sender_name + '\n' + this.consignment.con_sender_address_1 + '\n' + this.consignment.con_sender_town + ' ' + this.consignment.con_sender_postcode + '\n' + this.consignment.con_sender_contact + '\n' + this.consignment.con_sender_phone
    },
    receiverDetails () {
      return 'Receiver' + '\n' + this.consignment.con_receiver_name + '\n' + this.consignment.con_receiver_address_1 + '\n' + this.consignment.con_receiver_town + ' ' + this.consignment.con_receiver_postcode + '\n' + this.consignment.con_receiver_contact + '\n' + this.consignment.con_receiver_phone
    },
    itemDetails () {
      let details = ''
      this.consignment.items.forEach(item => {
        details += item.item_qty + ' @ ' + item.item_length + ' X ' + item.item_width + ' X ' + item.item_height + ' cms, ' + item.item_weight + 'kgs\n'
      })

      return details
    },
    activeViews () {
      if (Array.isArray(this.showCards)) {
        return this.showCards
      }

      return this.selectedViews
    }
  },
  created () {
    this.configuration = this.$_.cloneDeep(this.$store.getters.configuration)
    if (this.$_.isEmpty(this.configuration.layout.consignmentPagePreferences)) {
      this.selectedViews = [ '*' ]
    } else {
      this.selectedViews = this.configuration.layout.consignmentPagePreferences
    }
  },
  methods: {
    showCard (card) {
      return this.activeViews.includes(card) || this.activeViews.includes('*')
    },
    getPricingData () {
      const pricing = []
      if (this.consignment.pricing_data) {
        const pricingData = JSON.parse(this.consignment.pricing_data)
        if (pricingData.pricing_options) {
          Object.keys(pricingData.pricing_options).forEach(key => {
            pricing.push(pricingData.pricing_options[key])
          })
        }
      }
      return pricing
    },
    getExtData (key) {
      if (this.consignment.con_ext_data && this.consignment.con_ext_data.length) {
        let data = JSON.parse(this.consignment.con_ext_data)
        return data[key]
      }

      return '-'
    }
  }
}
</script>
